module.exports = {
  ANALYTICS_LOAD_TIMEOUT: 2000
};



// WEBPACK FOOTER //
// ./plugins/tracking/constants/PluginConstants.js